import type { IconMapping, LabelMapping, PermissionMapping, RouteNavObject } from "@/types/routes"
import type { RouteObject } from "@/utils/breadcrumbs/availableRoutes"
import { sortRoutesByLabelMapping } from "@/utils/utils"

interface IMapDataToRoute {
  route: RouteObject
  labelMapping: LabelMapping
  iconMapping: IconMapping
  permissionMapping?: PermissionMapping
}

const mapDataToRoute = ({ route, labelMapping, iconMapping, permissionMapping }: IMapDataToRoute): RouteNavObject => {
  const children = route.children?.map((child) =>
    mapDataToRoute({ route: child, labelMapping, iconMapping, permissionMapping })
  )

  const pathname = `/app${route.pathname}`

  return {
    ...route,
    pathname: route.pathname.startsWith("/app") ? route.pathname : `/app${route.pathname}`,
    label: labelMapping[pathname],
    icon: iconMapping[pathname],
    permissions: permissionMapping?.[pathname],
    children: children && sortRoutesByLabelMapping(children, labelMapping),
  }
}

export const formatNavRouteItems = (
  routes: RouteObject[],
  labelMapping: LabelMapping,
  iconMapping: IconMapping,
  permissionMapping?: PermissionMapping
): RouteNavObject[] => {
  const mappedRoutes = routes.map((route) => mapDataToRoute({ route, labelMapping, iconMapping, permissionMapping }))
  const visibleRoutes = mappedRoutes.filter((r) => Boolean(r.label))

  return sortRoutesByLabelMapping(visibleRoutes, labelMapping)
}
